<script>
    let dt = new Date().getFullYear();
</script>
<section id="Footer" class="bg-purple-700 p-5 text-center">
    <h3 class="font-display font-bold text-white p-3">&copy; Edustar Fastrack IELTS Coaching center {dt} </h3>
    <div class="font-body text-white flex justify-center items-center">
        <ul class="flex justify-center items-center flex-wrap">
            <li class="p-3"><a href="./index.html">Home</a></li>
            <li class="p-3"><a href="./privacy.html">Privacy Policiy</a></li>
<li class="p-3"><a href="./TermsAndConditions.html">Terms And Conditions</a></li>
        </ul>
    </div>
    <h3 class="font-body text-white p-3">Powered by <a href="https://infyplus.tech" class="font-bold">Infyplus Innovations</a> </h3>
</section>